export default __webpack_public_path__ + "static/media/babosch5.8612dc98.jpg";